import React from 'react';
import styled from 'styled-components';
import { Flex } from '../shared/Flex';

const Wrapper = styled(Flex)`
  position: relative;
  height: auto;
  min-height: 50px;
  width: 100%;
  justify-content: center;
  align-items: center;
  background-color: rgba(234, 179, 8, 0.9); // Yellow/Amber
  border-radius: 8px;
  padding: 10px;
  box-sizing: border-box;
`;

const Message = styled.div`
  padding: 5px;
  font-size: 14px;
  color: white;
  text-align: center;
`;

const WarningAlert = ({ message }) => {
  if (!message) {
    return null;
  }

  return (
    <Wrapper>
      <Message>{message}</Message>
    </Wrapper>
  );
};
export default WarningAlert;
